// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { css } from "styled-components";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import ProductModelNumber from "@store/Library/Components/ProductModelNumber";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsModelNumberStyles {
    container?: InjectableCss;
}

export const productDetailsModelNumberStyles: ProductDetailsModelNumberStyles = {
    container: {
        css: css`
            ${spacingStyles(null, pxToRem(12))}
        `,
    },
};

const styles = productDetailsModelNumberStyles;

const ProductDetailsModelNumber: React.FC<Props> = ({ product }) => {
    return (
        <StyledWrapper {...styles.container}>
            <ProductModelNumber product={product} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsModelNumber),
    definition: {
        displayName: "Product Model Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
